// src/pages/Contact.js
import React from "react";
import "./Contact.css";
import { Helmet } from "react-helmet";

const Contact = () => {
  return (
    <div>
        <Helmet>
            <title>Contact Us | Londonhouse </title>
        </Helmet>
    <div className="contaxt-container">
      <h2 className="contaxt-title">Contact Us</h2>
      <div className="contaxt-info">
        <p className="contaxt-item">
          <strong>Address:</strong>
          <br />
          London House School of English
          <br />
          4 Soi.8 Sripoom Road.,
          <br />
          Muang, Chiang Mai, Thailand 50200
        </p>
        <p className="contaxt-item">
          <strong>Phone:</strong> 053 218 948
        </p>
        <p className="contaxt-item">
          <strong>Email:</strong>{" "}
          <a href="mailto:londonhousechiangmai@gmail.com">
            londonhousechiangmai@gmail.com
          </a>
        </p>
        <p className="contaxt-item">
          <strong>Facebook:</strong>{" "}
          <a
            href="https://www.facebook.com/londonhousecm"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.facebook.com/londonhousecm
          </a>
        </p>
        <p className="contaxt-item">
          <strong>Tiktok:</strong> @londonhousechiangmai
        </p>
      </div>
    </div>
    </div>
  );
};

export default Contact;
